module.exports = __webpack_public_path__ + "static/media/1.2 Barbara Fassungsuntersung.4d3274da.jpg";